import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FinancialAccount } from "@common/types/financialAccount";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { EmptyCell } from "@components/history/views/cells/EmptyCell";
import { HistoryFinancialAccountDetailsRow } from "../views/historyFinancialAccountDetailsViewConfig";

export const HistoryFinancialAccountNameCell: React.FC<
    CellContext<ViewTableFeatures, HistoryFinancialAccountDetailsRow, unknown>
> = ({ row }) => {
    const account = row.original.resource as FinancialAccount | undefined;

    if (!account) {
        return <EmptyCell />;
    }

    const integrationAccount = account.integrationAccounts?.[0];
    const connection = integrationAccount?.integrationConnection as
        | IntegrationConnection
        | undefined;

    return (
        <ViewTableCell>
            <AccountCard
                account={account}
                connection={connection}
                showType={false}
                numberInName
                iconSize="sm"
            />
        </ViewTableCell>
    );
};
